export default {
  "pwaNotificationList.thead.no": "#序号",
  "pwaNotificationList.thead.taskId": "任务ID",
  "pwaNotificationList.thead.id": "ID",
  "pwaNotificationList.thead.bindSiteKey": "绑定站点",
  "pwaNotificationList.thead.title": "标题",
  "pwaNotificationList.thead.content": "内容",
  "pwaNotificationList.thead.url": "链接",
  "pwaNotificationList.thead.resultData": "结果数据",
  "pwaNotificationList.thead.taskStatus": "任务状态",
  "pwaNotificationList.thead.host": "主机",
  "pwaNotificationList.thead.channel": "渠道",
  "pwaNotificationList.thead.endpoint": "端点",
  "pwaNotificationList.thead.createdBy": "创建者",
  "pwaNotificationList.thead.updatedBy": "更新者",
  "pwaNotificationList.thead.createTime": "创建时间",
  "pwaNotificationList.thead.modifyTime": "修改时间",
  "pwaNotificationList.title": "PWA通知列表",
  "pwaNotificationList.action.reSend": "重新发送",
  "pwaNotificationList.action.details": "详情",
  "pwaNotificationList.action.delete": "删除",
  "pwaNotificationList.action.add": "添加",
  "pwaNotificationList.modal.title.details": "通知详情",
  "pwaNotificationList.modal.title.add": "发送消息",
  "pwaNotificationList.modal.title.edit": "编辑通知",
  "pwaNotificationList.confirm.delete.title": "删除通知",
  "pwaNotificationList.confirm.delete.content": "您确定要删除此通知吗？",
  "pwaNotificationList.confirm.resend.title": "重新发送通知",
  "pwaNotificationList.confirm.resend.content": "您确定要重新发送此通知吗？",
  "pwaNotificationList.message.copySuccess": "复制成功！",
  "pwaNotificationList.message.deleteSuccess": "删除成功！",
  "pwaNotificationList.message.resendSuccess": "重新发送成功！",
  "pwaNotificationList.message.addSuccess": "添加成功！",
  "pwaNotificationList.message.updateSuccess": "更新成功！",
};